export default __webpack_public_path__ + "static/sample-size-guidelines-d64beab3361099cdf9532bcd0a73733f.pdf";